import { Check, X } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import { FOR_LIST, NOT_FOR_LIST } from "@/lib/site";

export default function ForWhom() {
    return (
        <section
            data-testid="for-whom-section"
            className="relative bg-[#020617] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="text-center mb-16 flex flex-col items-center">
                    <Reveal>
                        <SectionLabel testId="forwhom-label">
                            Honest Filter
                        </SectionLabel>
                        <h2 className="mt-6 font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-3xl mx-auto">
                            This isn’t for{" "}
                            <span className="italic font-light">everyone</span>.
                            And we like it that way.
                        </h2>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#142142] border border-[#142142]">
                    <Reveal>
                        <div className="bg-[#020617] p-8 md:p-12 h-full border-l-2 border-[#D4AF37]">
                            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#D4AF37]">
                                Who It’s For
                            </p>
                            <h3 className="mt-3 font-display font-bold text-white text-2xl md:text-3xl">
                                The man ready to do the work
                            </h3>
                            <ul className="mt-8 space-y-4">
                                {FOR_LIST.map((item, i) => (
                                    <li
                                        key={i}
                                        data-testid={`for-item-${i + 1}`}
                                        className="flex items-start gap-3"
                                    >
                                        <Check
                                            size={20}
                                            className="text-[#D4AF37] mt-0.5 flex-shrink-0"
                                            strokeWidth={2.5}
                                        />
                                        <span className="text-white/85 leading-relaxed">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div className="bg-[#020617] p-8 md:p-12 h-full border-l-2 border-[#8B0000]">
                            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8B0000]">
                                Who It’s Not For
                            </p>
                            <h3 className="mt-3 font-display font-bold text-white text-2xl md:text-3xl">
                                Don’t bother applying if…
                            </h3>
                            <ul className="mt-8 space-y-4">
                                {NOT_FOR_LIST.map((item, i) => (
                                    <li
                                        key={i}
                                        data-testid={`not-for-item-${i + 1}`}
                                        className="flex items-start gap-3"
                                    >
                                        <X
                                            size={20}
                                            className="text-[#8B0000] mt-0.5 flex-shrink-0"
                                            strokeWidth={2.5}
                                        />
                                        <span className="text-white/65 leading-relaxed">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
